import { isString, isObject, has } from 'lodash'
import moment from 'moment'

export const isValidRoutingNumber = (value: any) =>
  /^[0-9]{9}$/.test(value) ? undefined : 'is not valid'

export const isValidAccountNumber = (value: any) =>
  /^[0-9]{7,14}$/.test(value) ? undefined : 'is not valid'

export const AccountingNumberMatch = (
  value = '',
  { accountNumber = '' } = {}
) =>
  !value || value === accountNumber
    ? undefined
    : 'must match with accounting number'

export const RoutingNumberMatch = (value = '', { routingNumber = '' } = {}) =>
  !value || value === routingNumber
    ? undefined
    : 'must match with accounting number'

export const isValidEmail = (email: string, values: any, field: any) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email) ? undefined : 'Enter valid email address'
}

export const isValidPhoneNo = (phoneNo: string) => {
  const phoneRe = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g
  return phoneRe.test(phoneNo)
}

export const isValidDate = (date: string) => {
  if (date) {
    if (!moment(date).isValid()) {
      return `${date} is not a valid date.`
    } else if (!moment(date, 'MM/DD/YYYY', true).isValid()) {
      return 'Invalid date Format. Format should be MM/DD/YYYY'
    } else if (moment(date).isAfter(moment())) {
      return 'DoB cannot be a future date'
    } else {
      return undefined
    }

  }

}

export const required = (value: any) => {
  if (isString(value)) {
    return value && value.trim() !== '' ? undefined : ' Required'
  } else if (isObject(value) && has(value, 'value')) {
    // @ts-ignore
    const selectValue = value.value
    return value && selectValue && selectValue !== '' ? undefined : ' Required'
  } else {
    return value || value === 0 ? undefined : ' Required'
  }
}

export const isZeroOrNegative = (value: any) =>
  value > 0 ? undefined : ' Can\'t be zero or negative'

export const isOneOrTwo = (value: any) =>
  value === 1 || value === 2 ? undefined : ' Should be either 1 or 2'

export const passwordsMustMatch = (value = '', { password = '' } = {}) =>
  !value || value === password ? undefined : ' must match with password'

export const isOnlySpaces = (value = '') =>
  !/\S/.test(value) ? ' Must contain spaces only' : undefined

export const isPositiveNumber = (value: any) => (value === undefined || value >= 0 ? undefined : ' Cannot be negative')
export const isPhoneNumber = (value: any) => {
  return (value && value.length === 12 ? undefined : undefined)
}

export const isIMEI = (value: any) => /^[0-9]{15}(,[0-9]{15})*$/.test(value) ? undefined : ' is not valid'
export const isNumberOnly = (value: any) => value ? (/^[\d]*$/.test(value) ? undefined : `can not be in decimal`) : undefined
export const isInches = (value: any) => value ? (/^[\d]*$/.test(value) && value >= 0 && value < 12 ? undefined : `should be between 0 - 12`) : undefined
export const isSeconds = (value: any) => value ? (/^[\d]*$/.test(value) && value >= 0 && value <= 60 ? undefined : `should be between 0 - 60`) : undefined
